__turbopack_context__.v({
  "container": "VHPp5W_container",
  "drawerOpen": "VHPp5W_drawerOpen",
  "footerSection": "VHPp5W_footerSection",
  "gridContainer": "VHPp5W_gridContainer",
  "headerSection": "VHPp5W_headerSection",
  "leftContainer": "VHPp5W_leftContainer",
  "rightContainer": "VHPp5W_rightContainer",
  "searchInputContainer": "VHPp5W_searchInputContainer",
  "wl": "VHPp5W_wl",
  "wrapper": "VHPp5W_wrapper",
});
